import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { TableModule } from 'src/app/common/utilities/table/table.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ModalModule } from 'src/app/common/components/modal/modal.module';
import { InputModule } from 'src/app/common/utilities/input/input/input.module';
import { ButtonOutlineModule } from 'src/app/common/utilities/buttons/button-outline/button-outline/button-outline.module';
import { DropdownModule } from 'src/app/common/utilities/dropdown/dropdown.module';
import { ErrorMessageModule } from 'src/app/common/components/error-message/error-message.module';
import { CopyTextModule } from 'src/app/common/utilities/copy-text/copy-text.module';
import { ToastModule } from 'primeng/toast';
import { ApiTableModule } from 'src/app/common/components/api-table/api-table.module';



@NgModule({
  declarations: [
    SettingsComponent
  ],
  imports: [
    CommonModule,
    ButtonFillModule,
    TableModule,
    DashboardModule,
    ModalModule,
    InputModule,
    ButtonOutlineModule,
    DropdownModule,
    ErrorMessageModule,
    CopyTextModule,
    ToastModule,
    ApiTableModule
  ]
})
export class SettingsModule { }
